import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import moment from 'moment';

import { Console } from '../../../tools';
import { time as constant } from '../../../constants';
import Group from './group';
import Helper from './helpers';
import Styled from './styled';

class QueryBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.schema = this.props.schema;
    this.console = new Console({
      dev: this.props.debug,
      name: this.props.title,
    });

    this.output = this.output.bind(this);
  }

  componentWillMount() {
    this.console.log('Ready');
  }

  shouldComponentUpdate(nextProps) {
    return Helper.comparison(this.props, nextProps);
  }

  componentDidUpdate() {
    this.console.log('Rendered');
  }

  output(key, schema) {
    this.console.group('Output Updated', () => {
      this.console.info('#p prev data', this.schema);
      this.console.info('#n next data', schema);
    });

    this.schema = { ...schema };
    this.props.output(this.schema);
  }

  render() {
    return (
      <Styled.QueryBuilder>
        <Group
          {...this.props.schema}
          console={this.console}
          fields={this.props.fields}
          index={0}
          isMobile={this.props.isMobile}
          main
          synchronize={this.output}
        />
      </Styled.QueryBuilder>
    );
  }
}

QueryBuilder.propTypes = {
  debug: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool,
  output: PropTypes.func,
  schema: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  title: PropTypes.string,
};

QueryBuilder.defaultProps = {
  debug: false,
  fields: [],
  isMobile: false,
  output: () => true,
  schema: {
    title: 'Query',
    rules: [{
      uuid: uuid(),
      field: 'RealDate',
      type: 'datetime',
      operator: '>',
      value: moment().subtract(1, 'days').format(constant.CREATE),
    }, {
      uuid: uuid(),
      field: 'RealDate',
      type: 'datetime',
      operator: '<',
      value: moment().format(constant.CREATE),
    }],
  },
  title: 'Query Builder',
};

export default QueryBuilder;
